<template>
    <div class="form-container px-4 py-4" style="border-radius: 35px;">
        <form id="reg-pwd-form" @submit.prevent="onSubmit" :class="{'d-none': isFormHidden}">
            <div class="row">

                <div class="col-12 text-center mb-3">
					<h1 class="fs-2-7">Scegli la tua password</h1>
                    <p class="fs-1-3 semibold font-family-juve">Deve avere almeno 8 caratteri, una lettera maiuscola, un numero e un carattere speciale.</p>
				</div>
                <div class="col-12 form-group mb-2">
                    <input type="text" name="u_nick" id="u_nick" class="form-control form-control-lg semibold rounded-pill" style="border:2px solid #9ac10c !important;" :value="uEmail" readonly required>
                </div>
                <div class="col-12 form-group mb-2">
                    <label class="mb-1" for="pwd">Password</label>
                    <input :type="pwdInputType" name="pwd" id="pwd" class="form-control form-control-lg pwd-show rounded-pill" minlength=8 maxlength=15 autocomplete="off" style="border:2px solid #9ac10c !important;" required v-model="form.pwd">
                    <i class="fa fa-eye" :class="{'fa-eye' : !showPwd, 'fa-eye-slash' : showPwd}" aria-hidden="true" @click.prevent="showHidePwd"></i>
                </div>
                <div class="col-12 form-group mb-2">
                <label class="mb-1" for="re-pwd">Conferma password</label>
                    <input :type="pwdInputType" name="re-pwd" id="re-pwd" class="form-control form-control-lg pwd-show rounded-pill" minlength=8 maxlength=15 autocomplete="off" style="border:2px solid #9ac10c !important;" required v-model="form.repwd">
                    <i class="fa fa-eye" :class="{'fa-eye' : !showPwd, 'fa-eye-slash' : showPwd}" aria-hidden="true" @click.prevent="showHidePwd"></i>
                </div>
                <div class="col-12 form-group text-center mt-4 mb-0">
                    <button id="sub_reg-pwd-form" type="submit" class="btn btn-green btn-lg rounded-pill px-5" :disabled="isSending"><span>SALVA</span> <i class="ms-1 fa fa-circle-o-notch fa-spin sub-loader" :class="{'d-none': !isSending}"></i></button>
                </div>

            </div>
        </form>

		<!-- Modal Confirm -->
		<modal name="thanks"
			height="auto"
			:adaptive=true
		>
			<div class="container text-center" style="background-color: #fff;">
				<div class="row lh-1">
					<div class="col-12 text-end px-2 pt-2">
						<i class="fas fa-times hover-default fs-2" @click.prevent="hideEmailModalThanks"></i>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="px-3 pb-3 pt-0 fs-1-3 mb-2 bold text-center" v-html="msgForm"></div>
					</div>
                    <div class="text-center col-12 mb-4" v-if="privateAreaUrl  && uRole == 'tea'">
                        <a :href="privateAreaUrl" class="btn btn-green btn-lg rounded-pill px-4"><span>ENTRA NELL’AREA DOCENTE</span></a>
                    </div>
				</div>
			</div>
		</modal>

    </div>
</template>

<script>
import axios from 'axios'

export default {
    props: ['uId', 'uRole', 'uFname', 'uLname', 'uEmail'],

    data() {
        return {
            ajaxObj: window.ajax_object,
            isSending: false,
            form: {
                pwd: '',
                repwd: ''
            },
            isFormHidden: false,
            msgForm: '',
            privateAreaUrl: '',
			showPwd: false,
			pwdInputType: 'password'
        }
    },

    methods: {
        onSubmit() {
            this.isSending = true
            let url = this.ajaxObj.ajax_url
            var data = new FormData();
            data.append('action', 'nl_confirm_reg')
            data.append('_nounce_value', this.ajaxObj._nounce_value)
            data.append('uid', this.uId)
            data.append('urole', this.uRole)
            data.append('u_nick', this.uEmail)
            data.append('u_fname', this.uFname)
            data.append('u_lname', this.uLname)
            data.append('pwd', this.form.pwd)
            data.append('re-pwd', this.form.repwd)

            axios.post(url, data)
                .then((response) => {
                    // console.log(response.data)
                    this.isSending = false
                    if(response.data.error == '') {
                        this.msgForm = response.data.msg
                        this.privateAreaUrl = response.data.site_url
                        this.isFormHidden = true
                    } else {
                        this.msgForm = response.data.error
                        this.privateAreaUrl = ''
                    }
                    this.$modal.show('thanks')
                }, (error) => {
                    this.isSending = false
                    console.log(error);
                });
        },

        hideEmailModalThanks() {
            this.msgForm = ''
            this.$modal.hide('thanks')
        },

		showHidePwd() {
			if(this.pwdInputType == 'password') {
				this.pwdInputType = 'text'
				this.showPwd = true
			} else {
				this.pwdInputType = 'password'
				this.showPwd = false
			}
		}
    }
}
</script>

<style scoped>
    .fas.fa-times {cursor: pointer !important;}
	.pwd-show {
		display: inline-block;
	}
	.fa.fa-eye {
		margin-left: -30px;
		cursor: pointer;
		color: #9ac10c;
	}
</style>